import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FaQuestionCircle, FaBars, FaTimes, FaStore } from 'react-icons/fa';
import logo from '../assets/image/logo.png';
const Nav = styled.nav`
  background-color: white;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LogoImage = styled.img`
  height: 150px;
  width: auto;
`;

const StoreIcon = styled(FaStore)`
  color: #1d3557;
  font-size: 24px;
  margin-right: 10px;
`;

const NavMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  transition: 0.3s ease-in-out;

  @media (max-width: 768px) {
    position: fixed;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 80px);
    background: white;
    top: 80px;
    left: ${({ $isOpen }) => ($isOpen ? '0' : '-100%')};
    padding: 40px 0;
    gap: 40px;
  }
`;

const NavLink = styled(ScrollLink)`
  color: #1d3557;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #e63946;
  }

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

export const AboutIcon = styled(RouterLink)`
  color: #1d3557;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s ease;
  display: flex;
  align-items: center;
  
  &:hover {
    color: #e63946;
  }

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const MobileIcon = styled.div`
  display: none;
  color: #1d3557;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #e63946;
  }

  @media (max-width: 768px) {
    display: block;
  }
`;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (location.pathname === '/gallery' || location.pathname === '/about') {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <Nav>
      <LogoContainer>
       
        <LogoImage src={logo} alt="New Malamba Business" />
      </LogoContainer>
      
      <MobileIcon onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </MobileIcon>

      <NavMenu $isOpen={isOpen}>
        <NavLink 
          to="home" 
          smooth={true} 
          duration={500} 
          onClick={closeMenu}
          spy={true}
        >
          Accueil
        </NavLink>
        <NavLink 
          to="products" 
          smooth={true} 
          duration={500} 
          onClick={closeMenu}
          spy={true}
        >
          Produits
        </NavLink>
        <NavLink 
          to="stores" 
          smooth={true} 
          duration={500} 
          onClick={closeMenu}
          spy={true}
        >
          Points de Vente
        </NavLink>
        <NavLink 
          to="contact" 
          smooth={true} 
          duration={500} 
          onClick={closeMenu}
          spy={true}
        >
          Contact
        </NavLink>
        <AboutIcon to="/about">
          <FaQuestionCircle />
        </AboutIcon>
      </NavMenu>
    </Nav>
  );
};

export default Navbar;